import { useSelector, useDispatch } from 'react-redux'
import {
  selectNotificationsList,
  selectIsNotificationsLoading,
} from '../../../store/notifications/selectors'
import { UserNotification, markAsReviewed } from '../../../store/notifications'

type UseBundleNotificationsDrawerType = {
  notifications: UserNotification[]
  loading: boolean
  markAsReviewedHandler: (id: number) => void
}

export const useBundleNotificationsDrawer = (): UseBundleNotificationsDrawerType => {
  const dispatch = useDispatch()
  const notifications = useSelector(selectNotificationsList)
  const loading = useSelector(selectIsNotificationsLoading)

  const markAsReviewedHandler = (id: number) => {
    dispatch(markAsReviewed(id))
  }

  return {
    notifications,
    loading,
    markAsReviewedHandler,
  }
}
